import React from "react";
import FormAddServices from "../../../components/portal/formsauthorization/FormAddServices";
import FormAuthCode from "../../../components/portal/formsauthorization/FormAuthCode";
import { Box, Typography } from "@mui/material";
import logo from "./../../../img/logore.png";

const Autorization = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "100%", md: "80%", lg: "80%" },
        }}
      >
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: "10%",
              height: "auto", // Reemplaza con la URL de tu imagen de fondo
              marginTop: "40px",
              marginLeft: "0px",
              position: "absolute",
            }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: 22, sm: 22, md: 30, lg: 30 },
            fontWeight: 600,
            textAlign: "center",
            marginTop: "40px",
          }}
        >
          PORTAL DE AUTORIZACIONES ARS RENACER
        </Typography>
        {/* -------- Formulario para validar el codigo  -------- */}
        <FormAuthCode />

        {/* -------- Formulario para agregar un servicio -------- */}
        <FormAddServices />
      </Box>
    </Box>
  );
};

export default Autorization;
